import Distribucio from "../../model/menudesign/Distribucio";

const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteDistribucio = async ( id_usu_log: string , page : string, distribucio : Distribucio) => {
    try {
        const response = await fetch(`${apiUrl}:8072/proveidors/distribucio/${id_usu_log}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(distribucio)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
